export default __webpack_public_path__ + "img/Inter-ThinItalic_7c76674.woff2";